export default __webpack_public_path__ + "static/media/phy.4a466dcc.jpg";